// import { canUseDOM } from 'exenv';

export function topPromoBarLoading(resp = {}, store = {}) {
  return {
    type: 'HOMEPAGE_PROMOTER_TOP_PROMO_BAR_LOADING',
    promoterTopPromoBar: resp,
    store
  };
}

export function topPromoBarLoaded(resp = {}, store = {}) {
  return {
    type: 'HOMEPAGE_PROMOTER_TOP_PROMO_BAR_LOADED',
    promoterTopPromoBar: resp,
    store
  };
}

export function topPromoBarLoadError(error, store = {}) {
  return {
    type: 'HOMEPAGE_PROMOTER_TOP_PROMO_BAR_ERROR',
    promoterTopPromoBar: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
